import { EmailOutlined } from "@mui/icons-material";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { countries } from "utility";
import PhoneCodeAutoComplete from "./select/PhoneCodeSelect";

export const PhoneTextInput = ({
  phoneCode = "64",
  data = {},
  inputType = "email",
  onChangePhoneCode = () => {},
  ...props
}) => {
  return (
    <Grid container spacing={2}>
      {inputType === "email" ? (
        <Grid item xs={12}>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlined color="primary" fontSize="large" />
                </InputAdornment>
              ),
            }}
            autoFocus
            {...props}
          />
        </Grid>
      ) : (
        <>
          <Grid item xs={3}>
            <PhoneCodeAutoComplete
              options={countries}
              value={phoneCode}
              onChange={onChangePhoneCode}
            />
          </Grid>
          <Grid item xs={9}>
            <TextField
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+{phoneCode}</InputAdornment>
                ),
              }}
              {...props}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
